

export class AddAdDto {
    name!: string;
    externalId!: string;
}